import { render, staticRenderFns } from "./CAccident.vue?vue&type=template&id=16f58292"
import script from "./CAccident.vue?vue&type=script&lang=js"
export * from "./CAccident.vue?vue&type=script&lang=js"
import style0 from "./CAccident.vue?vue&type=style&index=0&id=16f58292&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f58292')) {
      api.createRecord('16f58292', component.options)
    } else {
      api.reload('16f58292', component.options)
    }
    module.hot.accept("./CAccident.vue?vue&type=template&id=16f58292", function () {
      api.rerender('16f58292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CAccident.vue"
export default component.exports